import {Page} from '@/interfaces/server-data';

import {Component, Mixins} from 'vue-property-decorator';
import {AxiosPromise} from 'axios';
import {
  IModuleItem,
  IModuleItemSaveDto,
  TModuleType,
  IModuleItemQueryDto,
  IModuleItemResponseDto,
  IModuleItemFilterOptions,
  PromotionsExportPayload,
} from "@/pages/ModuleItems/data";

@Component
export default class ModuleApi extends Mixins() {
  private salesBasePath = '/api/sales';
  private promotionsBasePath = '/api/promotions';

  fetchItems(moduleType: TModuleType, query: IModuleItemQueryDto): AxiosPromise<Page<IModuleItemResponseDto[]>> {
    return this.$http.get(`${moduleType === 'promo' ? this.promotionsBasePath : this.salesBasePath}`, {params: query});
  }

  fetchItemsWithFilters(moduleType: TModuleType, filtersObject: any, usualParams: any) {
    function constructQuery(filtersObject: any, usualParams: any) {
      const queryParams = [];

      for (const key in filtersObject) {
        const value = filtersObject[key];
        const valueIsArray = Array.isArray(value);

        if (value !== null && (!valueIsArray || valueIsArray && value.length)) {
          queryParams.push(`${encodeURIComponent('filterField')}=${encodeURIComponent(key)}`);

          if (valueIsArray) {
            queryParams.push(`${encodeURIComponent('filterValue')}=${encodeURIComponent(value.join(';'))}`);
          } else {
            queryParams.push(`${encodeURIComponent('filterValue')}=${encodeURIComponent(value)}`);
          }
        }
      }

      for (const paramKey in usualParams) {
        queryParams.push(`${encodeURIComponent(paramKey)}=${encodeURIComponent(usualParams[paramKey])}`);
      }

      return queryParams.join('&');
    }

    const queryString = constructQuery(filtersObject, usualParams);

    return this.$http.get(`${moduleType === 'promo' ? this.promotionsBasePath : this.salesBasePath}?${queryString}`, {});
  }

  fetchFilterOptions(moduleType: TModuleType, tradingId: number): AxiosPromise<Page<IModuleItemFilterOptions[]>> {
    return this.$http.get(`${moduleType === 'promo' ? this.promotionsBasePath : this.salesBasePath}/options`, {params: { tradingId }});
  }

  saveItem(moduleType: TModuleType, itemParams: IModuleItemSaveDto): AxiosPromise<IModuleItem> {
    if (itemParams.id != null && itemParams.id > 0) {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

      return this.$http.patch(`${moduleType === 'promo' ? this.promotionsBasePath : this.salesBasePath}/${itemParams.id}`, itemParams, { params: { userId } });
    } else {
      return this.$http.post(moduleType === 'promo' ? this.promotionsBasePath : this.salesBasePath, itemParams);
    }
  }

  deleteItem(moduleType: TModuleType, id: number): AxiosPromise<any> {
    const auth = localStorage.getItem('AUTH');
    if (!auth) return Promise.reject();

    const { user_id: userId } = JSON.parse(auth);

    return this.$http.delete(`${moduleType === 'promo' ? this.promotionsBasePath : this.salesBasePath}/${id}`, { params: { userId } })
  }

  exportPromotions(payload: PromotionsExportPayload): AxiosPromise<any> {
    return this.$http.post(`${this.promotionsBasePath}/export`, payload);
  }
}
